import React from 'react'
import styled from 'styled-components'
import { sortableContainer } from 'react-sortable-hoc'

const SortableBg = styled.div`
  background-color: rgba(0, 0, 0, 0.2);
`

const SortableContainer = sortableContainer(({children}) => {
  return <SortableBg>{children}</SortableBg>
});

export default SortableContainer
